module.exports = __webpack_public_path__ + "static/media/Placeholder.069f5ada.svg";